"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TimeSeries_1 = __importDefault(require("../entity/TimeSeries"));
const luxon_1 = require("luxon");
class TimeSeriesStub extends TimeSeries_1.default {
    constructor({ datetime = luxon_1.DateTime.fromISO('2019-01-01T00:00:00'), value = 1000 } = {}) {
        super({ datetime, value });
    }
}
exports.default = TimeSeriesStub;
